<template>
  <header>
    <van-nav-bar
      title="登录"
      left-text="返回" 
      left-arrow
      @click-left="$router.go(-1)" 
    />
    <!-- <img style="width: 40%" src="../../assets/img/logo.png" alt /> -->
    <div class class="login pt-20 mt-5">
      <!-- 手机号码 -->
      <div class="handset flex jc-sb pb-5">
        <input
          v-model="phone"
          class="f14"
          type="text"
          placeholder="请输入手机号"
        />
        <input class="f12 bg-fff" type="button" :value="msg" @click="getCode" />
      </div>
      <!-- 验证码 -->
      <div class="handset flex jc-sb mt-20 pb-5">
        <input v-model="smsCode" class="f14" placeholder="请输入验证码" />
      </div>

      <!-- 密码 -->
      <div v-if="page === 'register'" class="handset flex jc-sb pb-5">
        <input v-model="password" class="f14" placeholder="请输入密码" />
      </div>

      <!-- 登录 -->
      <div class="mt-30">
        <van-button
          v-if="page === 'login'"
          style="width: 80%"
          type="danger"
          @click="login"
          >短信登录</van-button
        >
        <van-button v-else style="width: 80%" type="danger" @click="register"
          >立即注册</van-button
        >
      </div>
    </div>
  </header>
</template>

<script>
import login from "./loginMixin";
import register from "./registerMixin";
export default {
  mixins: [login, register],
  data() {
    return {
      password: "1234",
      phone: "13811112222",
      smsCode: "",
      msg: "获取短信验证码",
      count: 120,
      fetching: false,
    };
  },

  computed: {
    page() {
      return this.$route.path === "/login" ? "login" : "register";
    },
  },

  methods: {
    countDown() {
      this.fetching = true;
      let timer = setInterval(() => {
        this.msg = this.count--;
        if (this.count === 0) {
          clearInterval(timer);
          this.count = 120;
          this.msg = "重新获取验证码";
          this.fetching = false;
        }
      }, 1000);
    },

    async getCode() {
      if (this.fetching) return false;
      try {
        this.countDown();
        let res = await this.$axios.post("/user/getSmsCode", {
          phone: this.phone,
        });
        this.smsCode = res.smsCode;
      } catch (error) {
        this.$fail(error);
        this.fetching = false;
      }
    },
  },
};
</script>

<style lang="less" scoped>
@import "./index.less";
.handset {
  padding-right: 10%;
  padding-left: 10%;
}
</style>

